import React from "react";
import { type FreefieldInputProps } from "shared/utils/freeFields/models";
import FreefieldBoolean from "./FreefieldBoolean";
import FreefieldBooleanNullable from "./FreefieldBooleanNullable";
import FreefieldDate from "./FreefieldDate";
import FreefieldDateTime from "./FreefieldDateTime";
import FreefieldDecimal from "./FreefieldDecimal";
import FreefieldDropdown from "./FreefieldDropdown";
import FreefieldEmail from "./FreefieldEmail";
import FreefieldInteger from "./FreefieldInteger";
import FreefieldTextMultiLine from "./FreefieldTextMultiLine";
import FreefieldTextSingleLine from "./FreefieldTextSingleLine";
import FreefieldTimeSpan from "./FreefieldTimeSpan";
import FreefieldUrl from "./FreefieldUrl";

interface Props extends FreefieldInputProps {
  type: server.dto.FormElementTypes
  dropdownOptions?: server.dto.DropdownOption[]
  validatorKey: string
}

const FreefieldInput = (props: Props) => {
  const { type, ...rest } = props;

  if (type === "dropdown" && !props.dropdownOptions) throw new Error("Dropdown freefield must have dropdownItems");

  switch (type) {
    case "boolean": return <FreefieldBoolean {...rest} />;
    case "booleanNullable": return <FreefieldBooleanNullable {...rest} />;
    case "date": return <FreefieldDate {...rest} />;
    case "dateTime": return <FreefieldDateTime {...rest} />;
    case "decimal": return <FreefieldDecimal {...rest} />;
    case "dropdown": return <FreefieldDropdown {...rest} dropdownOptions={props.dropdownOptions} />;
    case "email": return <FreefieldEmail {...rest} validatorKey={props.validatorKey} />;
    case "integer": return <FreefieldInteger {...rest} />;
    case "percentage": return <FreefieldDecimal {...rest} />;
    case "textMultiLine": return <FreefieldTextMultiLine {...rest} />;
    case "textSingleLine": return <FreefieldTextSingleLine {...rest} />;
    case "time": return <FreefieldTimeSpan {...rest} />;
    case "url": return <FreefieldUrl {...rest} validatorKey={props.validatorKey} />;
    default: throw new Error("Unknown freefield definition type: " + type);
  }
};

export default FreefieldInput;